
import React, { useEffect, useState, match } from "react";
import AdminS from "layouts/AdminS";
import Footer from "components/Footer/Footer";
import validator from 'validator'
import Swal from "sweetalert2";

import { ToastContainer,toast, Zoom, Bounce } from 'react-toastify';
import "react-toastify/dist/ReactToastify.css";

// react-bootstrap components
import {
  Badge,
  Button,
  Card,
  Form,
  Navbar,
  Nav,
  Container,
  Row,
  Col,
  Table,
  DropdownButton,
  Dropdown,
  FormControl,
} from "react-bootstrap";

import firebase from "../firebase";

function ApproveAcc() {
  //store values
  const [emailError, setEmailError] = useState(true) 
  const[aCompany,setAcompany] = useState('');
  const[aNIC,setAnic] = useState('');
  const[aEmail,setAemail] = useState('');
  const[aFirstname,setAfirstname] = useState('');
  const[aLastname,setAlastname] = useState('');
  const[aAddress,setAadress] = useState('');
  const[aCity,setAcity] = useState('');
  const[aCountry,setAcountry] = useState('');
  const[aAge,setAage] = useState('');
  const[aAbtme,setAabtme] = useState('');

  const handleAddUser = () => {
    
    var email = aEmail;    
    
    if(aCompany && aNIC && aEmail && aFirstname && aLastname && aAddress && aCity && aCountry && aAge &&aAbtme){
      if (validator.isEmail(email)) {
        setEmailError(false) ; 
              const firestore = firebase.database().ref("/reqforaprooval");
              let data = {
               
                Company: aCompany,
                NIC: aNIC,
                Email: aEmail,
                FirstName: aFirstname,
                LastName: aLastname,
                Address: aAddress,
                City: aCity,
                Country: aCountry,
                Age: aAge,
                AboutMe: aAbtme,
                Status: 0,
              }
              firestore.push(data);
              alert("Succfully Registerted");
              setAcompany("");
              setAnic("");
              setAemail("");
              setAfirstname("");
              setAlastname("");
              setAadress("");
              setAcity("");
              setAcountry("");
              setAage("");
              setAabtme("");
            }
            else {
              setEmailError(false);
              Swal.fire(
                'Email Address?',
                'Invalid Email address',
                'warning'
              )  
       } 
            }
            else {
              alert("Please Fill all the Fields")
            }
   };

   const successToast = () => {

    toast("Sucessfully Registerted",{
    className: "custom-toast",
    draggable: true,
    position: toast.POSITION.TOP_RIGHT
    });
    };

    return (
        <>
        <AdminS/>
<br/>

<Container>

  <Row>
    <Col md={{ span: 12, offset: 1 }}>  

      <Container fluid>
        <Row>
          <Col md="12">
            <Card>
              <Card.Header>
                <Card.Title as="h4">Register Transport Manager</Card.Title>
              </Card.Header>
              <Card.Body>
              <Form>
                  <Row>
                    <Col className="pr-1" md="5">
                      <Form.Group>
                        <label>Company</label>
                        <Form.Control
                          focus value = {aCompany} onChange={(e)=>{setAcompany(e.target.value)}}
                          placeholder="Company"
                          type="text"
                        ></Form.Control>
                      </Form.Group>
                    </Col>
                    <Col className="px-1" md="3">
                      <Form.Group>
                        <label>NIC</label>
                        <Form.Control
                          focus value = {aNIC} onChange={(e)=>{setAnic(e.target.value)}}
                          placeholder="NIC"
                          type="number"
                        ></Form.Control>
                      </Form.Group>
                    </Col>
                    <Col className="pl-1" md="4">
                      <Form.Group>
                        <label htmlFor="exampleInputEmail1">
                          Email address
                        </label>
                        <Form.Control type="email"
                          focus value = {aEmail} onChange={(e)=>{setAemail(e.target.value)}}
                          placeholder="Email"
                        ></Form.Control>
                      </Form.Group>
                      
                    </Col>
                  </Row>
                  <Row>
                    <Col className="pr-1" md="6">
                      <Form.Group>
                        <label>First Name</label>
                        <Form.Control
                          focus value = {aFirstname} onChange={(e)=>{setAfirstname(e.target.value)}}
                          placeholder="First Name"
                          type="text"
                        ></Form.Control>
                      </Form.Group>
                    </Col>
                    <Col className="pl-1" md="6">
                      <Form.Group>
                        <label>Last Name</label>
                        <Form.Control
                          focus value = {aLastname} onChange={(e)=>{setAlastname(e.target.value)}}
                          placeholder="Last Name"
                          type="text"
                        ></Form.Control>
                      </Form.Group>
                    </Col>
                  </Row>
                  <Row>
                    <Col md="12">
                      <Form.Group>
                        <label>Address</label>
                        <Form.Control
                          focus value = {aAddress} onChange={(e)=>{setAadress(e.target.value)}}
                          placeholder="Home Address"
                          type="text"
                        ></Form.Control>
                      </Form.Group>
                    </Col>
                  </Row>
                  <Row>
                    <Col className="pr-1" md="4">
                      <Form.Group>
                        <label>City</label>
                        <Form.Control 
                          
                          focus value = {aCity} onChange={(e)=>{setAcity(e.target.value)}}
                          placeholder="City"
                          type="text"
                        ></Form.Control>
                      </Form.Group>
                    </Col>
                    <Col className="px-1" md="4">
                      <Form.Group>
                        <label>Country</label>
                        <Form.Control
                          focus value = {aCountry} onChange={(e)=>{setAcountry(e.target.value)}}
                          placeholder="Country"
                          type="text"
                        ></Form.Control>
                      </Form.Group>
                    </Col>
                    <Col className="pl-1" md="4">
                      <Form.Group>
                        <label>Age</label>
                        <Form.Control
                          focus value = {aAge} onChange={(e)=>{setAage(e.target.value)}}
                          placeholder="age"
                          type="text"
                        ></Form.Control>
                      </Form.Group>
                    </Col>
                  </Row>
                  <Row>
                    <Col md="12">
                      <Form.Group>
                        <label>About Me</label>
                        <Form.Control
                          cols="80"
                          focus value = {aAbtme} onChange={(e)=>{setAabtme(e.target.value)}}
                          placeholder="description about you"
                          rows="4"
                          as="textarea"
                        ></Form.Control>
                      </Form.Group>
                    </Col>
                  </Row>
                  <ToastContainer />
                  <Button
                    onClick={()=>{handleAddUser(); successToast();}}
                    className="btn-fill pull-right"
                    type="button"
                    variant="primary"
                    size="" 
                    active
                  >
                    Register
                  </Button>
                </Form>
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </Container>
      </Col>
  </Row>

</Container>


<Footer /> 
    </>
     ) ;
    }
    
export default ApproveAcc;